import { IDeleteTreinamentoUseCase } from "../../../presentation/useCases/delete/delete_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteTreinamentoUseCase
 */

export class DeleteTreinamentoUseCase implements IDeleteTreinamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteTreinamento(
    idTreinamento: number,
  ): Promise<void> {
    await this.repository.deleteTreinamento(
      idTreinamento,
    );
  }
}
